import { makeAutoObservable } from 'mobx';

interface SEOData {
  title: string;
  description: string;
  keywords: string;
}

class SEOStore {
  title = '인기 검색어 - 11번가';

  description =
    '11번가 슈팅배송 - 11번가 인기 검색어 트렌드 페이지 입니다. 고객들이 어떤 검색어를 많이 찾았고 쇼핑했는지 둘러보세요.';

  keywords = '';

  mwUrl = 'http://search.11st.co.kr/MW/search/popularKeyword?domain=mw';

  constructor() {
    makeAutoObservable(this);
  }

  setSEOData = (data: SEOData) => {
    if (!data) return;

    const { title, description, keywords } = data;

    this.setTitle(title);
    this.setDescription(description);
    this.setKeywords(keywords);
  };

  setTitle = (title: string) => {
    this.title = title;
  };

  setDescription = (description: string) => {
    this.description = description;
  };

  setKeywords = (keywords: string) => {
    this.keywords = keywords;
  };
}
export default new SEOStore();
